import {CheckboxOptionType} from "antd";
import {PagesPathnames} from "../../../../app/types/ad";

export const placingAdOptions = [
    { label:"Автоматическое размещение",value: PagesPathnames.autoPlacement},
    { label: "Ручное размещение", value: PagesPathnames.manualPlacement },
] as (string | number | CheckboxOptionType)[]
